<template>
  <div class="admin__a-tab-content admin__a-tab-content--show">
    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.lot-number')}}:</div>
      <p class="a-input a-input--disabled">{{retend.lot.num}}</p>
    </div>
    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.lot-name')}}:</div>
      <p class="a-input a-input--disabled">{{retend.lot.name}}</p>
    </div>
    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.retend-serial')}}:</div>
      <p class="a-input a-input--disabled">{{retend.num}}</p>
    </div>
    <div class="a-container-form " v-if="retend.state && retend.state.valid">
      <div class="a-label a-label--w-280">{{$t('form.retend.status')}}:</div>
      <p class="a-input a-input--disabled">{{$t(retend.state.label)}}</p>
    </div>
    <div class="a-container-form " v-if="retend.reason">
      <div class="a-label a-label--w-280">{{$t('form.retend.reason')}}:</div>
      <p class="a-input a-input--disabled">{{retend.reason}}</p>
    </div>


    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.retend-date')}}:</div>
      <div  class="a-input-group" v-if="canEditRetend || canEditStartDate" >
        <date-picker @change="onDateChanged" v-model="retendDay"></date-picker>
      </div>
      <date-time class="a-input a-input--disabled" :value="retendDay" :time="false" v-else></date-time>
    </div>
    <div class="a-container-form" :class="{'a-input-group--error': $v.start.$error || $v.end.$error }">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.retend-start-time')}}:</div>
      <cleave class="a-input a-input--w-80"
              v-model="retendStartTime"
              :raw="false"
              :options="time"
              @blur="onStartTimeChanged"
              :disabled="!retendDay"
              v-if="canEditRetend || canEditStartDate">
      </cleave>
      <p class="a-input a-input--disabled" v-else>{{retendStartTime}}</p>
    </div>

    <div class="a-container-form" v-if="retend.permissions.CAN_CHANGE_RETEND_DURATION">
      <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="canEditStartDate = true" v-if="!canEditStartDate">
        {{$t('buttons.change-rentend-start-date')}}
      </button>
      <template v-if="canEditStartDate">
        <button class="gui-btn gui-btn--red gui-btn--w-184" @click.prevent="onStartTimeChangeSaveClick" >
          {{$t('buttons.save')}}
        </button>
        <button class="gui-btn gui-btn--red gui-btn--w-184 u-margin-left-20" @click.prevent="canEditStartDate = false" >
          {{$t('buttons.cancel')}}
        </button>
      </template>
    </div>

    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.max-period-before-first-bid')}}:</div>
      <input type="tel" class="a-input a-input--w-80" data-mask="000" placeholder="число" v-model.number="retend.waitingTime" v-if="canEditRetend" @blur="saveForm">
      <p class="a-input a-input--disabled" v-else>{{retend.waitingTime}}</p>
      <p class="a-input a-input--disabled u-padding-left-17">минут</p>
    </div>
    <div class="a-container-form " :class="{'a-input-group--error': $v.start.$error || $v.end.$error}">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.retend-end-time')}}:</div>
      <cleave class="a-input a-input--w-80" v-model="retendEndTime" :raw="false" :options="time" @blur="saveForm" :disabled="!retendDay" v-if="canEditRetend"></cleave>
      <p class="a-input a-input--disabled" v-else>{{retendEndTime}}</p>
    </div>
    <div class="a-container-form ">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.initiator-email')}}:</div>
      <p class="a-input a-input--disabled">{{retend.lot.email}}</p>
    </div>

    <div class="a-container-form ">
      <div class="a-label--w-280 u-width-100">
        <div class="a-checkbox">
          <label class="a-checkbox__label">
            <input class="a-checkbox__input"
                   type="checkbox"
                   :checked="retend.antisniper"
                   :disabled="!canEditRetend || !retend.antisniper"
                   @click="onAntisniperClick">
            <span class="a-checkbox__icon"></span>
            <span class="a-checkbox__text">
               Антиснайпер:
            </span>
          </label>
        </div>
      </div>
      <div>
        <div class="a-flex-start">
          <input-number class="a-input a-input--w-80" v-model="retend.antisniper" :disabled="!canEditRetend" @change="saveForm"></input-number>
          <label class="u-width-450px u-padding-left-17">минут на автоматическое продление торгов в случае поступления предложения от участников за это же количество минут до времени окончания переторжки</label>
        </div>
        <div class="u-padding-top-12px">
          <div class="a-checkbox">
            <label class="a-checkbox__label">
              <input class="a-checkbox__input" type="checkbox" v-model="retend.showAntisniper" :disabled="!canEditRetend" @change="saveForm">
              <span class="a-checkbox__icon"></span>
              <span class="a-checkbox__text">
               Показывать участникам
            </span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="a-container-form " v-if="canConfigureRetendStep">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.retend-step')}}:</div>
      <input-cost class="a-input a-input--w-100" v-if="canEditRetend" v-model="retend.step" @blur="saveForm"></input-cost>
      <p class="a-input a-input--disabled" v-else>{{retend.step | price}}</p>
      <dropdown-new class="select-w-77"
                    v-model="retend.currency"
                    :options="enums.Currency.options.NOT_EMPTY"
                    v-if="canEditRetend" @change="saveForm">
        <option :value="enums.Currency.EMPTY">%</option>
      </dropdown-new>
      <p class="a-input a-input--disabled" v-else>{{retend.currency.EMPTY ? '%' : $t(retend.currency.label)}}</p>
    </div>

    <div class="a-container-form " v-if="canConfigureRetendCompareMode">
      <div class="a-label a-label--w-280">{{$t('form.retend.lot-overview.comparing-mode')}}:</div>
      <dropdown-new class="select-w-120" v-model="retend.compareMode" v-if="canEditRetend" @change="saveForm">
        <option :label="'compare-mode.none'" disabled></option>
        <option :value="enums.CompareMode.NORMAL" :label="'compare-mode.normal'" ></option>
        <option :value="enums.CompareMode.AVERAGE" :label="'compare-mode.average'" ></option>
      </dropdown-new>
      <p class="a-input a-input--disabled" v-else>{{$t(retend.compareMode.label)}}</p>
    </div>

    <confirmation-dialog ref="confirmation" close-on-action>
    </confirmation-dialog>
  </div>
</template>

<script>
  import Currency from '@/api/types/currency'
  import CompareMode from '@/api/types/compare-mode'
  import Cleave from 'vue-cleave-component'
  import { required, requiredIf, numeric, sameAs } from '@/validators'
  import CommonMixins from '../mixins/common'
  import PermissionsMixins from '../mixins/permissions'
  import ConfirmationDialog from '@/components/common/dialogs/ConfirmationDialog'

  export default {
    props: {
      retend: Object,
      lot: Object
    },

    mixins: [
      CommonMixins,
      PermissionsMixins
    ],

    components: {
      Cleave,
      ConfirmationDialog
    },

    validations: {
      start: {
        required,

        inFuture: function() {
          return this.start >= new Date();
        }
      },

      end: {
        required: requiredIf(function () {
          return this.canEditRetend;
        }),

        afterStart: function () {
          if (this.$v.retend.waitingTime.$invalid) {
            return false
          }

          if (this.$v.start.$invalid) {
            return false
          }

          const minEnd = new Date(this.start.getTime() + this.retend.waitingTime * 60000);
          return this.retend.endTime > minEnd;
        }
      },

      retend: {
        waitingTime: {
          required,
          numeric
        }
      }
    },

    data: () => ({
      start: undefined,
      end: undefined,
      canEditStartDate: false,
      backup: {
        startTime: undefined
      }
    }),

    watch: {
      canEditStartDate(value) {
        if (value) {
          this.backup.startTime = new Date(this.retend.startTime);
        }
        else if (this.backup.startTime) {
          this.retend.startTime = this.backup.startTime;
        }
      }
    },

    computed: {
      canConfigureRetendStep() {
        return !this.lot.methods.actual.REDUCTION;
      },

      canConfigureRetendCompareMode() {
        return !this.lot.methods.actual.REDUCTION;
      },

      time() {
        return {
          time: true,
          timePattern: ['h', 'm'],
          delimiter: ':'
        }
      },

      retendDay: {
        get: function() {
          return this.retend.startTime;
        },

        set: function(value, vm) {
          if (this.retend.startTime) {
            this.retend.startTime.setDate(value.getDate());
            this.retend.startTime.setMonth(value.getMonth());
            this.retend.startTime.setFullYear(value.getFullYear());
          }
          else {
            this.retend.startTime = new Date(value);
          }

          if (this.retend.endTime) {
            this.retend.endTime.setDate(value.getDate());
            this.retend.endTime.setMonth(value.getMonth());
            this.retend.endTime.setFullYear(value.getFullYear());
          }
          else {
            this.retend.endTime = new Date(value);
          }

          this.start = new Date(this.retend.startTime);
          this.end = new Date(this.retend.endTime);
        }
      },

      retendStartTime: {
        get: function() {
          if (this.retend.startTime) {
            const h = ('0' + this.retend.startTime.getHours()).slice(-2);
            const m = ('0' + this.retend.startTime.getMinutes()).slice(-2);

            return h + ':' + m;
          }
        },

        set: function(value) {
          const parts = value.split(':');
          if (parts.length !== 2) return;

          this.retend.startTime.setHours(+parts[0], +parts[1], 0);
          this.start = new Date(this.retend.startTime);
        }
      },

      retendEndTime: {
        get: function() {
          if (this.retend.endTime) {
            const h = ('0' + this.retend.endTime.getHours()).slice(-2);
            const m = ('0' + this.retend.endTime.getMinutes()).slice(-2);

            return h + ':' + m;
          }
        },

        set: function(value) {
          const parts = value.split(':');
          if (parts.length !== 2) return;

          this.retend.endTime.setHours(+parts[0], +parts[1], 0);
          this.end = new Date(this.retend.endTime);
        }
      }
    },

    methods: {
      async onDateChanged() {
        await this.saveForm()
      },

      async onStartTimeChanged() {
        if (this.canEditRetend) {
          await this.saveForm();
        }
      },

      async onStartTimeChangeSaveClick() {
        this.$v.$touch();
        if (this.$v.$invalid) return;

        this.$refs.confirmation.open({
          title: 'Изменение начала переторжки',
          text: 'Вы уверены что хотите изменить время начала переторжки?',

          onConfirm: () => {
            this.runBlockerAction(async () => {
              try {
                await this.$store.dispatch('changeActiveRetendStartDate', {
                  lotId: this.lot.id,
                  date: this.retend.startTime
                });
                this.backup.startTime = undefined;
                this.canEditStartDate = false;
              }
              catch(e) {
                console.log('failed enabling active retend editing', e);
                this.globalErrorHandler(e);
              }
            });
          }
        });
      },

      async onAntisniperClick() {
        this.retend.antisniper = undefined;
        await this.saveForm();
      }
    }
  }
</script>

<style scoped>

</style>
